



































































import { Component, Vue } from 'vue-property-decorator';
import { State, Getter } from 'vuex-class';
import { User, World, SocketState } from '../../types';
import moment from 'moment';
import UserControl from '@/components/UserControl.vue';
import ActivityIndicator from '../../components/ActivityIndicator.vue';

@Component({
    components: { ActivityIndicator, UserControl },
})

export default class Forum extends Vue {
    @State public socket!: SocketState;
    @State public user!: User;
    @State public world!: World;

    public currentForumIndex = 0;
    public mainForums = [
        {
            title: 'GrandQuest',
            description: 'The main forum, dedicated to the development of GrandQuest',
            boards: [
                {
                    id: 1,
                    title: 'Announcements',
                    description: `
                            Welcome to the GrandQuest announcements!
                            We regularly update you on the occurrences in our world here
                        `,
                },
                {
                    id: 2,
                    title: 'Bug Reporting',
                    description: 'Find bugs and report them to us so we can remove them!',
                },
            ],
        },
        {
            title: 'Art',
            description: 'Dedicated to the discussion of music, painting, poetry.',
            boards: [
                {
                    id: 3,
                    title: 'Music',
                    description: `
                        A board for the appreciation of music and music theory
                    `,
                }
            ]
        },
        { title: 'General', description: 'A forum for discussing general topics.', boards: [] },
    ];

    public selectedForum() {
        const index = this.$data.currentForumIndex;
        return this.$data.mainForums[index];
    }
    public setForum(index: number) {
        this.$data.currentForumIndex = index;
    }
    public setBoard(board: { id: number, title: string, description: string }) {
      this.$router.replace(`/board/${board.id}`);
    }
    public setShowcaseClass() {
        const selectedForum = this.$data.mainForums[this.$data.currentForumIndex];
        const title = selectedForum.title.toLowerCase().trim();

        return 'grid ' + title;
    }
    public setSelectorClass(forum: { title: string }) {
        const title = forum.title.toLowerCase().trim();
        const selectedForum = this.$data.mainForums[this.$data.currentForumIndex];
        let className = title;

        if (selectedForum.title.toLowerCase().trim() === title) {
            className += ' active';
        }

        return className;
    }
    public sinceDate(date: string) {
        return moment(date).fromNow();
    }
    get timeOfDay() {
        return moment(this.world.timeOfDay).format("ddd, MMM Do, ha");
    }
}
